import { ReactNode, useEffect, useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  animation?: 'fade-in-up' | 'fade-in-left' | 'fade-in-right';
  delay?: number;
}

export const AnimatedSection = ({ 
  children, 
  className = '', 
  animation = 'fade-in-up',
  delay = 0 
}: AnimatedSectionProps) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShouldAnimate(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [isVisible, delay]);

  return (
    <div
      ref={ref}
      className={`${className} transition-all duration-700 ease-out ${
        shouldAnimate 
          ? 'opacity-100 translate-y-0 translate-x-0' 
          : animation === 'fade-in-up' 
            ? 'opacity-0 translate-y-10'
            : animation === 'fade-in-left'
              ? 'opacity-0 -translate-x-10'
              : 'opacity-0 translate-x-10'
      }`}
    >
      {children}
    </div>
  );
};
